import { FC, ReactElement } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../store';
import { BUSINESS_UNITS, BusinessUnit } from '@cambridgeassessment/lib-ee-commons';
import cieBrand from './cie.brand';
import ocrBrand from './ocr.brand';
import { Brand } from './brand';

const brands: Record<BusinessUnit['id'], Brand> = {
  [BUSINESS_UNITS.CIE.id]: cieBrand,
  [BUSINESS_UNITS.OCR.id]: ocrBrand,
};

export function brandedFC<PROPS = {}>(render: (brand: Brand, props: PROPS) => ReactElement | null): FC<PROPS> {
  return (props: PROPS): ReactElement<PROPS> | null => {
    const { businessUnit } = useSelector((state: RootState) => state.userData);
    const brand = businessUnit?.id && brands[businessUnit.id];
    if (brand) {
      return render(brand, props);
    } else {
      logger.error({
        message: 'Brand for BusinessUnit not found',
        data: businessUnit,
      });
      return null;
    }
  };
}
